import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import * as logger from "../../../logger";
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Checkbox,
    withStyles,
    FormControlLabel,
    Typography,
    Switch
} from '@material-ui/core';
import { getSingleInvoice, editInvoice } from '../../../store/actions/tripActionCreator';
import { connect } from "react-redux";
import { SingleInvoiceCss } from './InvoiceCss';
import { Button } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { getMilliDatePickerDateInStringDDMMMYYYY, numberFormat } from '../../../utils/utils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { LandScapeIconGrey } from "../../../components/icons";
import EditIcon from '@material-ui/icons/Edit';
import YourDetailsSideBar from '../../components/InvoiceSidebarAndDialog/YourDetailsSideBar';
import PartyDetailsSideBar from '../../components/InvoiceSidebarAndDialog/PartyDetailsSideBar';
import InvoiceDetailsSideBar from '../../components/InvoiceSidebarAndDialog/InvoiceDetailsSideBar';
import ChargesAndDeductionsSideBar from '../../components/InvoiceSidebarAndDialog/ChargesAndDeductionsSideBar';
import { VerifiedBankAccountIcon } from '../../../components/icons';
import UpdateBankUpiDialog from '../../components/Dialog/UpdateBankUpiDialog';
import SelectBankSideBar from '../../components/InvoiceSidebarAndDialog/SelectBankSideBar';
import TermsAndConditionsDialog from '../../components/InvoiceSidebarAndDialog/TermAndConditionsDialog';
import S3Uploader from '../../components/s3Uploader/s3Uploader';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import DeleteIcon from '@material-ui/icons/Delete';
import TransactionDetailsSideBar from '../../components/InvoiceSidebarAndDialog/TransactionDetailsSideBar';
import DeleteTransactionDialog from '../../components/InvoiceSidebarAndDialog/DeleteTransactionDialog';
import { updateChatView } from "../../../store/actions/userActionCreators";
import AddBankDetailsSideBar from '../../components/InvoiceSidebarAndDialog/AddBankDetailsSideBar';
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import { trackDwebEvent } from '../../analytics';
import GSTDetailsSideBar from '../../components/InvoiceSidebarAndDialog/GSTDetailsSideBar';

const CustomCheckbox = withStyles({
    root: {
        color: '#c7c7c7',
        '&$checked': {
            color: '#0033cc',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CustomSwitch = withStyles({
    switchBase: {
        '&$checked': {
            color: '#0033cc',
        },
        '&$checked + $track': {
            backgroundColor: '#0033cc',
        },
    },
    checked: {},
    track: {},
})(Switch);

const SingleInvoice = ({ trip, user, dispatchGetSingleInvoice, dispatchChatView, dispatchEditInvoice }) => {

    const [singleInvoiceData, setSingleInvoiceData] = useState({});
    const [editInvoice, setEditInvoice] = useState(false);
    const [editYourDetails, setEditYourDetails] = useState(false);
    const [recall, setRecall] = useState(false);
    const [editPartyDetails, setEditPartyDetails] = useState(false);
    const [editGSTInfoDetails, setEditGSTInfoDetails] = useState(false);
    const [editInvoiceDetails, setEditInvoiceDetails] = useState(false);
    const [editChargeDeduction, setEditChargeDeduction] = useState(false);
    const [upiCheckFlag, setUpiCheckFlag] = useState(false);
    const [updateUpiDialog, setUpdateUpiDialog] = useState(false);
    const [bankChangeOpen, setBankChangeOpen] = useState(false);
    const [termsAndConditionValue, setTermsAndConditionValue] = useState(null);
    const [termsAndConditionFlag, setTermsAndConditionFlag] = useState("");
    const [signatureLinkValue, setSignatureLinkValue] = useState("");
    const [transactionDetail, setTransactionDetail] = useState({});
    const [paymentDeleteDialog, setPaymentDeleteDialog] = useState(false);
    const [addBankDetailsOpen, setAddBankDetailsOpen] = useState(false);
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [tripInfoData, setTripInfoData] = useState({});
    const [partyDetailsCheck, setPartyDetailsCheck] = useState(false);
    const [logo, setLogo] = useState("");
    const [initialLoad, setInitialLoad] = useState(false);
    const [accordionExpanded, setAccordionExpanded] = useState("panel1");
    const [includeSignatureToggle, setIncludeSignatureToggle] = useState(false);

    const location = useLocation();
    const classes = SingleInvoiceCss();

    useEffect(() => {

        const invoiceInfo = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {}

        trackDwebEvent('Dweb Single Invoice Page', {
            party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
            party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
            count_of_trips: invoiceInfo && invoiceInfo.trips ? invoiceInfo.trips.length : 0,
            total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
            invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
            invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
            due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : "",
            invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
            invoice_balance: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.balance ? invoiceInfo.amounts.balance : 0
        });

    }, []);

    useEffect(() => {

        dispatchChatView(true);

        dispatchGetSingleInvoice(invoiceIdValue,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Invoice Dweb", "Get Single Invoice Successfull");
                    if (initialLoad && data.response) {
                        const invoiceInfo = data.response;
                        trackDwebEvent('Dweb Invoice edit Invoice details changed', {
                            party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
                            party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
                            count_of_trips: invoiceInfo && invoiceInfo.trips && invoiceInfo.trips.length ? invoiceInfo.trips.length : 0,
                            total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
                            invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
                            invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
                            due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : 0,
                            invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
                            party_company_name: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.companyName ? invoiceInfo.customerGSTDetails.companyName : "",
                            party_gst_number: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.gstNumber ? invoiceInfo.customerGSTDetails.gstNumber : "",
                            user_company_name: invoiceInfo && invoiceInfo.userGSTDetails && invoiceInfo.userGSTDetails.companyName ? invoiceInfo.userGSTDetails.companyName : "",
                            user_gst_number: invoiceInfo && invoiceInfo.userGSTDetails && invoiceInfo.userGSTDetails.gstNumber ? invoiceInfo.userGSTDetails.gstNumber : "",
                            gst_percentage: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.gstPercentage ? invoiceInfo.otherDetails.gstPercentage : "",
                            terms_and_conditions: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.termsAndConditions ? invoiceInfo.otherDetails.termsAndConditions : "",
                            signature_url: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.signatureLink ? invoiceInfo.otherDetails.signatureLink : ""
                        })
                    }
                }
            },
            () => {
                logger.log("Single Invoice Dweb", "Get Single Invoice Failed");
            }
        );

        setInitialLoad(true);

    }, [recall]);

    useEffect(() => {

        const customerDetails = trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.customerGSTDetails ? trip.singleInvoiceInfo.customerGSTDetails : {};

        if (trip && trip.singleInvoiceInfo) {
            setSingleInvoiceData(trip.singleInvoiceInfo)
        }

        if (trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.otherDetails && trip.singleInvoiceInfo.otherDetails.termsAndConditions) {
            setTermsAndConditionValue(trip.singleInvoiceInfo.otherDetails.termsAndConditions);
        } else {
            setTermsAndConditionValue(null);
        }

        if (trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.otherDetails && trip.singleInvoiceInfo.otherDetails.signatureLink) {
            setSignatureLinkValue(trip.singleInvoiceInfo.otherDetails.signatureLink);
        } else {
            setSignatureLinkValue(null);
        }

        if (customerDetails && !customerDetails.companyName) {
            setPartyDetailsCheck(true);
        } else {
            setPartyDetailsCheck(false);
        }

        if (trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.otherDetails && trip.singleInvoiceInfo.otherDetails.logoLink) {
            setLogo(trip.singleInvoiceInfo.otherDetails.logoLink);
        } else {
            setLogo("");
        }

        if (trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.otherDetails && "includeSignature" in trip.singleInvoiceInfo.otherDetails) {
            setIncludeSignatureToggle(trip.singleInvoiceInfo.otherDetails.includeSignature)
        }

    }, [trip.singleInvoiceInfo]);


    useEffect(() => {

        if (trip && (trip.editInvoiceFlag || trip.editInvoiceFlag == false)) {
            setEditInvoice(trip.editInvoiceFlag);
        }

    }, [trip.editInvoiceFlag]);

    let path = location && location.pathname ? location.pathname.split("/") : [];
    let invoiceIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const muiColumns = [
        {
            name: "startDate",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fwNormal}>{getMilliDatePickerDateInStringDDMMMYYYY(value)}</span>
                }
            },
        },
        {
            name: "lrNumber",
            label: "LR Number",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fwNormal}>{value ? value : "--"}</span>
                }
            },
        },
        {
            name: "",
            label: "Route",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips[dataIndex] ? singleInvoiceData.trips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.divAlignV1}>
                                <div>{rowData && rowData.sourceLocation ? rowData.sourceLocation : ""}</div>
                                &nbsp;to&nbsp;
                                <div>{rowData && rowData.destinationLocation ? rowData.destinationLocation : ""}</div>
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "truckNumber",
            label: "Truck",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fwNormal}>{value ? value : "--"}</span>
                }
            },
        },
        {
            name: "id",
            label: "Rate",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips[dataIndex] ? singleInvoiceData.trips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.fwNormal}>{rowData && rowData.rate && rowData.rate != "Fixed" ? rowData.rate : "--"}</div>
                        </>
                    )
                }
            },
        },
        {
            name: "amounts",
            label: "Freight",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips[dataIndex] ? singleInvoiceData.trips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.textV3}>{numberFormat(rowData && rowData.amounts && rowData.amounts.freight ? rowData.amounts.freight : 0)}</div>
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "amounts",
            label: "Charges",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips[dataIndex] ? singleInvoiceData.trips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.divAlignV5}>
                                <div className={classes.fwNormal}>{numberFormat(rowData && rowData.amounts && rowData.amounts.charges ? rowData.amounts.charges : 0)}</div>
                                {editInvoice && singleInvoiceData && singleInvoiceData.invoiceDetails && (singleInvoiceData.invoiceDetails.invoiceStatus).toLowerCase() != "paid" &&
                                    <div className={classes.mlV1}>
                                        <IconButton className={classes.editIconButton} onClick={() => handleChargesDeductionsEdit(rowData)}>
                                            <EditIcon className={classes.editIcon} />
                                        </IconButton>
                                    </div>
                                }
                            </div>
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={editInvoice ? classes.thTruckRightAlignV1 : classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "amounts",
            label: "Deductions",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips[dataIndex] ? singleInvoiceData.trips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.divAlignV5}>
                                <div className={classes.fwNormal}>{numberFormat(rowData && rowData.amounts && rowData.amounts.deductions ? rowData.amounts.deductions : 0)}</div>
                                {editInvoice && singleInvoiceData && singleInvoiceData.invoiceDetails && (singleInvoiceData.invoiceDetails.invoiceStatus).toLowerCase() != "paid" &&
                                    <div className={classes.mlV1}>
                                        <IconButton className={classes.editIconButton} onClick={() => handleChargesDeductionsEdit(rowData)}>
                                            <EditIcon className={classes.editIcon} />
                                        </IconButton>
                                    </div>
                                }
                            </div>
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={editInvoice ? classes.thTruckRightAlignV1 : classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "amounts",
            label: "Total",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips[dataIndex] ? singleInvoiceData.trips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.textV3}>{numberFormat(rowData && rowData.amounts && rowData.amounts.revenue ? rowData.amounts.revenue : 0)}</div>
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            }
        }
    ]

    const muiData = singleInvoiceData && singleInvoiceData.trips && singleInvoiceData.trips.length > 0 ? singleInvoiceData.trips : [];
    const options = {
        filterType: "multiselect",
        fixedHeader: true,
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
    };

    const handleEditYourDetails = () => {
        setEditYourDetails(true);
    }

    const handleYourDetailsClose = () => {
        setEditYourDetails(false);
    }

    const handleYourDetailsConfirm = () => {
        setEditYourDetails(false);
        setRecall(!recall)
    }

    const handlePartyDetailsEdit = () => {
        setEditPartyDetails(true);
    }
    const handleGSTInfoDetailsEdit = () => {
        setEditGSTInfoDetails(true);
    }

    const handlePartyDetailsClose = () => {
        setEditPartyDetails(false);
    }
    const handleGSTInfoDetailsClose = () => {
        setEditGSTInfoDetails(false);
    }

    const handlePartyDetailsConfirm = () => {
        setEditPartyDetails(false);
        setRecall(!recall);
    }
    const handleGSTInfoDetailsConfirm = () => {
        setEditGSTInfoDetails(false);
        setRecall(!recall);
    }

    const handleEditInvoiceDetails = () => {
        setEditInvoiceDetails(true);
    }

    const handleInvoiceDetailsClose = () => {
        setEditInvoiceDetails(false);
    }

    const handleInvoiceDetailsConfirm = () => {
        setEditInvoiceDetails(false);
        setRecall(!recall);
    }

    const handleChargesDeductionsEdit = (tripData) => {
        setTripInfoData(tripData ? tripData : {});
        setEditChargeDeduction(true);
    }

    const handleChargeDeductionClose = () => {
        setTripInfoData({});
        setEditChargeDeduction(false);
    }

    const handleUpiCheckChange = (event) => {

        setUpiCheckFlag(event && event.target && event.target.checked ? event.target.checked : false);

        if (event && event.target && event.target.checked) {
            setUpdateUpiDialog(true);
        }

    }

    const handleUpiDialogClose = () => {
        setUpdateUpiDialog(false);
        setUpiCheckFlag(false);
    }

    const handleUpiDialogConfirm = () => {
        setUpdateUpiDialog(false);
        setRecall(!recall);
    }

    const handleBankChangeClick = () => {
        setBankChangeOpen(true);
    }

    const handleSelectBankSideBarClose = () => {
        setBankChangeOpen(false);
    }

    const handleSelectBankSideBarConfirm = () => {
        setBankChangeOpen(false);
        setRecall(!recall);
    }

    const handleTermsChange = () => {
        setTermsAndConditionFlag(true);

        const invoiceInfo = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {};

        if (!termsAndConditionValue) {
            trackDwebEvent('Dweb Invoice More Info entered', {
                party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
                party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
                count_of_trips: invoiceInfo && invoiceInfo.trips && invoiceInfo.trips.length ? invoiceInfo.trips.length : 0,
                total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
                invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
                invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
                due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : 0,
                invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
                party_company_name: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.companyName ? invoiceInfo.customerGSTDetails.companyName : "",
                party_gst_number: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.gstNumber ? invoiceInfo.customerGSTDetails.gstNumber : ""
            })
        }
    }

    const handleTermsClose = () => {
        setTermsAndConditionFlag(false);
    }

    const handleTermsConfirm = (value) => {
        setTermsAndConditionValue(value);
        setTermsAndConditionFlag(false);
    }

    const handleAddExpensePhoto = (value) => {

        const invoiceInfo = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {};

        if (!signatureLinkValue) {
            trackDwebEvent('Dweb Invoice More Info entered', {
                party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
                party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
                count_of_trips: invoiceInfo && invoiceInfo.trips && invoiceInfo.trips.length ? invoiceInfo.trips.length : 0,
                total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
                invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
                invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
                due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : 0,
                invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
                party_company_name: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.companyName ? invoiceInfo.customerGSTDetails.companyName : "",
                party_gst_number: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.gstNumber ? invoiceInfo.customerGSTDetails.gstNumber : ""
            })
        }

        const reqData = {
            otherDetails: {
                signatureLink: value ? value : "",
                includeSignature: true
            }
        }

        dispatchEditInvoice(invoiceIdValue, reqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Single Invoice Dweb', 'Edit Invoice Successfull');
                    setSignatureLinkValue(value);
                    setIncludeSignatureToggle(true);
                    if (data.response) {
                        const invoiceInfo = data.response;
                        trackDwebEvent('Dweb Invoice edit More info changed', {
                            party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
                            party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
                            count_of_trips: invoiceInfo && invoiceInfo.trips && invoiceInfo.trips.length ? invoiceInfo.trips.length : 0,
                            total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
                            invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
                            invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
                            due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : 0,
                            invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
                            party_company_name: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.companyName ? invoiceInfo.customerGSTDetails.companyName : "",
                            party_gst_number: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.gstNumber ? invoiceInfo.customerGSTDetails.gstNumber : "",
                            user_company_name: invoiceInfo && invoiceInfo.userGSTDetails && invoiceInfo.userGSTDetails.companyName ? invoiceInfo.userGSTDetails.companyName : "",
                            user_gst_number: invoiceInfo && invoiceInfo.userGSTDetails && invoiceInfo.userGSTDetails.gstNumber ? invoiceInfo.userGSTDetails.gstNumber : "",
                            gst_percentage: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.gstPercentage ? invoiceInfo.otherDetails.gstPercentage : "",
                            terms_and_conditions: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.termsAndConditions ? invoiceInfo.otherDetails.termsAndConditions : "",
                            signature_url: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.signatureLink ? invoiceInfo.otherDetails.signatureLink : ""
                        })
                    }
                }
            },
            () => {
                logger.log('Single Invoice Dweb', 'Edit Invoice Failed');
            }
        )
    }

    const handleAddBankDetailsClose = () => {
        setAddBankDetailsOpen(false);
    }

    const handleAddBankDetailsConfirm = (status) => {
        if (status) {
            handleSuccessOpen()
            setTimeout(() => {
                handleSuccessClose()
            }, 3000);
        } else {
            handleFailureOpen()
            setTimeout(() => {
                handleFailureClose()
            }, 3000);
        }
        setRecall(!recall);
        setAddBankDetailsOpen(false);

    }

    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }

    const handleSuccessClose = () => {
        setSuccessCreation(false)
    }

    const handleFailureOpen = () => {
        setFailureCreation(true)
    }

    const handleFailureClose = () => {
        setFailureCreation(false)
    }

    const handleAddLogo = (value) => {

        const reqData = {
            otherDetails: {
                logoLink: value ? value : "",
            }
        }

        dispatchEditInvoice(invoiceIdValue, reqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Single Invoice Dweb', 'Edit Logo Successfull');
                    setLogo(value);
                }
            },
            () => {
                logger.log('Single Invoice Dweb', 'Edit Logo Failed');
            }
        )

    }

    const handleAddPaymentDetails = () => {
        setAddBankDetailsOpen(true);
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setAccordionExpanded(isExpanded ? panel : false);
    };

    const handleSignatureToggleChange = (event) => {
        setIncludeSignatureToggle(event.target.checked)

        const reqData = {
            otherDetails: {
                includeSignature: event.target.checked
            }
        }

        dispatchEditInvoice(invoiceIdValue, reqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Single Invoice Dweb', 'Include signature flag change Successfull');
                }
            },
            () => {
                logger.log('Single Invoice Dweb', 'Include signature flag change Failed');
            }
        )

    }

    return (
        <>
            <div className={classes.divContainer}>

                {/* ************************************ 1st Row ************************************ */}
                <div>
                    <div className={classes.titleV1}>YOUR DETAILS</div>

                    <Grid
                        container
                        wrap="nowrap"
                        className={classes.gridV1}
                    >

                        <Grid container wrap="nowrap" className={classes.gridContainerV3}>
                            <div className={classes.divOuterBox} >
                                {!logo &&
                                    <>
                                        {editInvoice ?
                                            <S3Uploader directoryName={"dweb-images/Single-Invoice/AddLogo"} fromSingleInvoice={true} handleFile={handleAddLogo} id={"addLogo"} />
                                            :
                                            <div className={classes.divInnerBox}>
                                                <LandScapeIconGrey />
                                            </div>
                                        }
                                    </>
                                }
                                {logo &&
                                    <>
                                        <img src={logo} className={classes.imgV2} />
                                        {editInvoice &&
                                            <S3Uploader directoryName={"dweb-images/Single-Invoice/AddLogo"} fromSingleInvoice={true} handleFile={handleAddLogo} id={"editLogo"} />
                                        }
                                    </>
                                }
                            </div>
                        </Grid>

                        <Grid container direction="column" wrap="nowrap">

                            <Grid container wrap="nowrap" justify="space-between" className={classes.pdV2}>
                                <Grid item className={classes.titleV2}>
                                    {singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.companyName ? singleInvoiceData.userGSTDetails.companyName : "--"}
                                </Grid>
                                {editInvoice &&
                                    <Grid item>
                                        <Button variant="outlined" className={classes.editButton} onClick={() => handleEditYourDetails()}>
                                            Edit
                                        </Button>
                                    </Grid>
                                }
                            </Grid>

                            <Divider classes={{ root: classes.dividerRoot }} />

                            <Grid container direction="column" className={classes.pdV3}>

                                {/* ************************************ Your Details first row . ************************************ */}
                                <Grid container wrap="nowrap">
                                    <Grid container wrap="nowrap" direction="column" xs={16}>
                                        <Grid item className={classes.titleV3}>Address line 1</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.addressLine1 ? singleInvoiceData.userGSTDetails.addressLine1 : "--"}</Grid>
                                    </Grid>

                                    <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={6}>
                                        <Grid item className={classes.titleV3}>State</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.state ? singleInvoiceData.userGSTDetails.state : "--"}</Grid>
                                    </Grid>

                                    <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={6}>
                                        <Grid item className={classes.titleV3}>GST Number</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.gstNumber ? singleInvoiceData.userGSTDetails.gstNumber : "--"}</Grid>
                                    </Grid>

                                    <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={8}>
                                        <Grid item className={classes.titleV3}>Email Address</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.email ? singleInvoiceData.userGSTDetails.email : "--"}</Grid>
                                    </Grid>
                                </Grid>

                                {/* ************************************ Your Details second row . ************************************ */}
                                <Grid container wrap="nowrap" className={classes.mtV1}>
                                    <Grid container wrap="nowrap" direction="column" xs={9} classes={{ "grid-xs-9": classes.gridWidthV1 }}>
                                        <Grid item className={classes.titleV3}>Address line 2</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.addressLine2 ? singleInvoiceData.userGSTDetails.addressLine2 : "--"}</Grid>
                                    </Grid>

                                    <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={3} classes={{ "grid-xs-3": classes.gridWidthV2 }} >
                                        <Grid item className={classes.titleV3}>Pincode</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.pincode ? singleInvoiceData.userGSTDetails.pincode : "--"}</Grid>
                                    </Grid>

                                    {/* <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={6}>
                                        <Grid item className={classes.titleV3}>PAN Number</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.panNumber ? singleInvoiceData.userGSTDetails.panNumber : "--"}</Grid>
                                    </Grid> */}

                                    <Grid container wrap="nowrap" direction="column" className={classes.paddingStartV1} xs={7} classes={{ "grid-xs-7": classes.gridWidthV3 }}>
                                        <Grid item className={classes.titleV3}>Mobile</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.contactNumber ? singleInvoiceData.userGSTDetails.contactNumber : "--"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>


                {/* ************************************ 2nd Row ************************************ */}
                <div className={classes.divAlign}>

                    <div className={classes.divWidth}>
                        <div className={classes.titleV1}>PARTY DETAILS</div>
                        <Grid container direction="column" className={classes.gridV1}>

                            {partyDetailsCheck &&
                                <>
                                    <Grid container alignItems="center" justify="center" direction="column" className={classes.gridContainerV4}>
                                        <Button variant="outlined" className={classes.addBankButton} onClick={() => handlePartyDetailsEdit()}>
                                            + Add Party Details
                                        </Button>
                                    </Grid>
                                </>
                            }

                            {!partyDetailsCheck &&
                                <>
                                    <Grid container wrap="nowrap" justify="space-between" className={classes.pdV2}>
                                        <Grid item className={classes.titleV2}>
                                            {singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.companyName ? singleInvoiceData.customerGSTDetails.companyName : "--"}
                                        </Grid>
                                        {editInvoice && !partyDetailsCheck &&
                                            <Grid item>
                                                <Button variant="outlined" className={classes.editButton} onClick={() => handlePartyDetailsEdit()}>
                                                    Edit
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>

                                    <Divider classes={{ root: classes.dividerRoot }} />


                                    <Grid container direction="column" className={classes.pdV3}>

                                        <Grid container wrap="nowrap">
                                            <Grid container wrap="nowrap" direction="column">
                                                <Grid item className={classes.titleV3}>Address line 1</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.addressLine1 ? singleInvoiceData.customerGSTDetails.addressLine1 : "--"}</Grid>
                                            </Grid>

                                            <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={6}>
                                                <Grid item className={classes.titleV3}>State</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.state ? singleInvoiceData.customerGSTDetails.state : "--"}</Grid>
                                            </Grid>

                                            <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={6}>
                                                <Grid item className={classes.titleV3}>GST Number</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.gstNumber ? singleInvoiceData.customerGSTDetails.gstNumber : "--"}</Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid container wrap="nowrap" className={classes.mtV1}>
                                            <Grid container wrap="nowrap" direction="column">
                                                <Grid item className={classes.titleV3}>Address line 2</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.addressLine2 ? singleInvoiceData.customerGSTDetails.addressLine2 : "--"}</Grid>
                                            </Grid>

                                            <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={12}>
                                                <Grid item className={classes.titleV3}>Pincode</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.pincode ? singleInvoiceData.customerGSTDetails.pincode : "--"}</Grid>
                                            </Grid>

                                            {/* <Grid container wrap="nowrap" direction="column" className={classes.paddingStart} xs={6}>
                                        <Grid item className={classes.titleV3}>PAN Number</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.panNumber ? singleInvoiceData.customerGSTDetails.panNumber : "--"}</Grid>
                                    </Grid> */}
                                        </Grid>
                                    </Grid>
                                </>
                            }

                        </Grid>
                    </div>

                    <div className={classes.divWidthV1}>
                        <div className={classes.titleV1}>INVOICE DETAILS</div>
                        <Grid container wrap="nowrap" className={classes.gridV3} direction="column">

                            <Grid container wrap="nowrap" justify="space-between" className={classes.pdV2}>
                                <Grid item className={classes.titleV2}>{singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceNumber ? singleInvoiceData.invoiceDetails.invoiceNumber : ""}</Grid>
                                {editInvoice &&
                                    <Grid item>
                                        <Button variant="outlined" className={classes.editButton} onClick={() => handleEditInvoiceDetails()}>
                                            Edit
                                        </Button>
                                    </Grid>
                                }
                            </Grid>

                            <Divider classes={{ root: classes.dividerRoot }} />

                            <Grid container wrap="nowrap" direction="column" className={classes.pdV3}>

                                <Grid container wrap="nowrap">
                                    <Grid container wrap="nowrap" direction="column">
                                        <Grid item className={classes.titleV3}>Invoice Date</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleInvoiceData.invoiceDetails.invoiceDate) : "--"}</Grid>
                                    </Grid>
                                    <Grid container wrap="nowrap" direction="column">
                                        <Grid item className={classes.titleV3}>Due Date</Grid>
                                        <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.dueDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleInvoiceData.invoiceDetails.dueDate) : "--"}</Grid>
                                    </Grid>
                                </Grid>

                                <Grid container wrap="nowrap" direction="column" className={classes.mtV1}>
                                    <Grid item className={classes.titleV3}>Due In</Grid>
                                    <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.invoiceDetails && (singleInvoiceData.invoiceDetails.dueIn || singleInvoiceData.invoiceDetails.dueIn == 0) ? singleInvoiceData.invoiceDetails.dueIn == 1 ? singleInvoiceData.invoiceDetails.dueIn + " " + "day" : singleInvoiceData.invoiceDetails.dueIn + " " + "days" : "--"}</Grid>
                                </Grid>

                            </Grid>

                        </Grid>
                    </div>

                </div>

                {/* *********************************** 3rd row. *********************************** */}
                <div className={classes.mtV4}>
                    <div className={classes.titleV1}>TRIP DETAILS</div>
                    <div className={classes.divTable}>
                        <MUIDataTable data={muiData} columns={muiColumns} options={options} />
                    </div>
                </div>

                {/* *********************************** 4th row. ***********************************  */}
                <div className={classes.divAlignV2} >

                    <div className={classes.divWidthV2}>
                        <div className={classes.titleV1}>BANK DETAILS</div>
                        <Grid container wrap="nowrap" direction="column" className={classes.gridV1}>

                            {editInvoice && singleInvoiceData && singleInvoiceData.bankDetails && !singleInvoiceData.bankDetails.bankId &&
                                <>
                                    <Grid container alignItems="center" justify="center" direction="column" className={classes.gridContainerV4}>
                                        <Button variant="outlined" className={classes.addBankButton} onClick={() => handleAddPaymentDetails()}>
                                            + Add Payment Details
                                        </Button>
                                    </Grid>
                                </>
                            }


                            {((!editInvoice) || (editInvoice && singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.bankId)) &&
                                <>
                                    <Grid container wrap="nowrap" justify="space-between" className={classes.pdV2}>
                                        <Grid item className={classes.titleV2}>{singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.accountHolderName ? singleInvoiceData.bankDetails.accountHolderName : "--"}</Grid>
                                        {editInvoice &&
                                            <Grid item>
                                                <Button variant="outlined" className={classes.changeButton} onClick={() => handleBankChangeClick()}>
                                                    Change
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>

                                    <Divider classes={{ root: classes.dividerRoot }} />

                                    <Grid container wrap="nowrap" direction="column" className={classes.pdV3}>
                                        <Grid container wrap="nowrap">
                                            <Grid container wrap="nowrap" direction="column" className={classes.endPadding}>
                                                <Grid item className={classes.titleV3}>Account Number</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.accountNumber ? singleInvoiceData.bankDetails.accountNumber : "--"}</Grid>
                                            </Grid>
                                            <Grid container wrap="nowrap" direction="column">
                                                <Grid item className={classes.titleV3}>IFSC code</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.ifscCode ? singleInvoiceData.bankDetails.ifscCode : "--"}</Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container className={classes.mtV1}>
                                            <Grid container wrap="nowrap" direction="column" xs={6} className={classes.endPadding}>
                                                <Grid item className={classes.titleV3}>Bank Name</Grid>
                                                <Grid item className={classes.textV1}>{singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.bankName ? singleInvoiceData.bankDetails.bankName : "--"}</Grid>
                                            </Grid>
                                            {singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.upiAddress &&
                                                <Grid container wrap="nowrap" direction="column" xs={6}>
                                                    <Grid item className={classes.titleV3}>UPI Address</Grid>
                                                    <Grid item className={classes.textV1}>{singleInvoiceData.bankDetails.upiAddress}</Grid>
                                                </Grid>
                                            }
                                            {singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.brokerVerificationStatus &&
                                                <Grid container wrap="nowrap" alignItems="center" xs={6} className={singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.upiAddress ? classes.mtV5 : ""}>
                                                    <VerifiedBankAccountIcon />
                                                    <Grid item className={classes.verifiedText}>Verified Account</Grid>
                                                </Grid>
                                            }
                                        </Grid>

                                        {editInvoice && !singleInvoiceData.bankDetails.upiAddress && singleInvoiceData.bankDetails.bankId &&
                                            <div className={classes.mtV1}>
                                                <FormControlLabel
                                                    control={<CustomCheckbox checked={upiCheckFlag} classes={{ label: classes.checkboxText }} onChange={(event) => handleUpiCheckChange(event)} name="upiCheck" />}
                                                    label="Include UPI Address"
                                                />
                                            </div>
                                        }
                                    </Grid>
                                </>
                            }

                        </Grid>
                    </div>

                    <div className={classes.divWidthV3}>
                        <div className={classes.titleV1}>MORE DETAILS</div>
                        <div className={classes.moreDetailsContainer}>
                            <>
                                <div className={classes.divButtonContainer}>
                                    {!termsAndConditionValue && editInvoice &&
                                        <Button className={classes.addTermsButton} onClick={() => handleTermsChange()}>
                                            + Add Terms & Conditions
                                        </Button>
                                    }
                                    {termsAndConditionValue ?
                                        <>
                                            <div className={classes.termsContainer}>
                                                <div className={classes.divAlignV4}>
                                                    <div className={classes.textV2}>Terms & Conditions</div>
                                                    {editInvoice &&
                                                        <div>
                                                            <Button variant="outlined" className={classes.changeButton} onClick={() => handleTermsChange()}>
                                                                Change
                                                            </Button>
                                                        </div>
                                                    }
                                                </div>
                                                <div className={classes.termsContent}>
                                                    {"\"" + termsAndConditionValue + "\""}
                                                </div>
                                            </div>
                                        </>

                                        :

                                        <>
                                            {!editInvoice &&
                                                <div className={classes.termsContainerV1}>
                                                    Terms & Conditions
                                                </div>
                                            }
                                        </>
                                    }

                                </div>


                                <div className="div-button-containerV1">
                                    {editInvoice && !signatureLinkValue &&
                                        <S3Uploader directoryName={"dweb-images/Single-Invoice/Signature"} fromSingleInvoiceAddSignature={true} handleFile={handleAddExpensePhoto} id={"addSignature"} />
                                    }
                                    {signatureLinkValue ?
                                        <>
                                            <div className={classes.signatureContainer}>
                                                <div className={classes.divAlignV4}>
                                                    <div className={classes.textV2}>Signature</div>
                                                    {editInvoice &&
                                                        <div>
                                                            <S3Uploader directoryName={"dweb-images/Single-Invoice/Signature"} fromSingleInvoiceEditSignature={true} handleFile={handleAddExpensePhoto} id={"changeSignature"} />
                                                        </div>
                                                    }
                                                </div>
                                                <div className={classes.signatureContent}>
                                                    <img src={signatureLinkValue ? signatureLinkValue : ""} className={classes.imgV1} />
                                                </div>
                                                {editInvoice &&
                                                    <div className={classes.divAlignV10}>
                                                        <div className={classes.signatureText}>Include Signature in Invoice</div>
                                                        <CustomSwitch
                                                            checked={includeSignatureToggle}
                                                            onChange={handleSignatureToggleChange}
                                                            classes={{ track: classes.switchTrack, thumb: classes.switchThumb }}
                                                            className={classes.mt5}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </>

                                        :

                                        <>
                                            {!editInvoice &&
                                                <div className={classes.termsContainerV1}>
                                                    Signature
                                                </div>
                                            }
                                        </>
                                    }

                                </div>
                            </>
                        </div>
                    </div>

                    <div className={classes.divWidthV4}>
                        <div className={classes.titleV4}>PAYMENTS & BALANCE</div>
                        <Grid container wrap="nowrap" direction="column" className={classes.gridV2}>
                            <Grid container wrap="nowrap" justify="space-between" className={classes.invoiceAmountContainer}>
                                <Grid item>Invoice Amount</Grid>
                                <Grid item className={classes.fw600}>{numberFormat(singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.revenue ? singleInvoiceData.amounts.revenue : 0)}</Grid>
                            </Grid>

                            {singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.transactions && singleInvoiceData.invoiceDetails.transactions.length == 0 ?
                                <Grid container wrap="nowrap" justify="space-between" className={classes.paymentsReceivedContainer}>
                                    <Grid item>Payments Received</Grid>
                                    <Grid item className={classes.fw600}>{numberFormat(0)}</Grid>
                                </Grid>
                                :
                                <Grid item className={classes.gridItemV1}>
                                    <Accordion classes={{ root: classes.boxShadow }}
                                        expanded={accordionExpanded === 'panel1'}
                                        onChange={handleChange('panel1')}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            classes={{ content: classes.accordionContent, expandIcon: classes.iconButtonAccordion, root: classes.accordionSummaryRoot }}
                                        >
                                            <div className={classes.divAlignV4}>
                                                <div>
                                                    Payments Received
                                                </div>
                                                <div className={classes.fw600}>
                                                    {numberFormat(singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.paid ? singleInvoiceData.amounts.paid : 0)}
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails classes={{ root: classes.pdV1 }}>
                                            <div className={classes.widthV1}>
                                                {singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.transactions && singleInvoiceData.invoiceDetails.transactions.map((transactionData, index) => (
                                                    <>
                                                        <div className={index != 0 ? classes.divAlignV8 : classes.divAlignV9}>
                                                            <div className={classes.divAlignV6}>
                                                                <div className={classes.textV4}>{transactionData && transactionData.paymentMode ? transactionData.paymentMode : ""}</div>
                                                                <FiberManualRecord className={classes.dotV1}></FiberManualRecord>
                                                                <div className={classes.textV4}>{transactionData && transactionData.date ? getMilliDatePickerDateInStringDDMMMYYYY(transactionData.date) : ""}</div>
                                                            </div>
                                                            <div className={classes.divAlignV7}>
                                                                <div className={classes.textV5}>
                                                                    {transactionData && transactionData.amount ? numberFormat(transactionData.amount) : ""}
                                                                </div>
                                                                {/* <IconButton className={classes.deleteIconButton} onClick={() => handlePaymentDelete(transactionData)}>
                                                                    <DeleteIcon className={classes.deleteIcon} />
                                                                </IconButton> */}
                                                            </div>
                                                        </div>
                                                    </>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            }


                            <div>
                                <hr className={classes.hrV1} />
                            </div>

                            <Grid container wrap="nowrap" justify="space-between" className={classes.balanceAmountContainer}>
                                <Grid item>Balance Amount</Grid>
                                <Grid item className={classes.fw600}>{numberFormat(singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.balance ? singleInvoiceData.amounts.balance : 0)}</Grid>
                            </Grid>
                        </Grid>
                        <div className={classes.addGSTSection}>
                            <>
                                {
                                    singleInvoiceData && singleInvoiceData.gstInfo && !singleInvoiceData.gstInfo.addGST && <Button disabled={!editInvoice} variant="outlined" fullWidth={true} onClick={() => { handleGSTInfoDetailsEdit() }} className={classes.addGSTButton}>+ ADD GST %
                                    </Button>
                                }
                                {singleInvoiceData && singleInvoiceData.gstInfo && singleInvoiceData.gstInfo.addGST &&
                                    <>
                                        <div className={classes.addGSTInfo}>
                                            <Typography className={classes.gstRC}>GST Under Reverse Charge</Typography>
                                            {editInvoice &&
                                                <Button variant="outlined" className={classes.editButton} onClick={() => handleGSTInfoDetailsEdit()}>
                                                    Edit
                                                </Button>
                                            }
                                        </div>

                                        {singleInvoiceData && singleInvoiceData.gstInfo.gstDisplayInfo && singleInvoiceData.gstInfo.gstDisplayInfo.map((gstRowInfo, index) => (
                                            <div className={index % 2 != 0 ? classes.gstPercentageV1 : classes.gstPercentage}>
                                                <Typography className={classes.fs14}>
                                                    {gstRowInfo && gstRowInfo.displayName ? gstRowInfo.displayName : ""}
                                                </Typography>
                                                <Typography className={classes.gstAmount}>
                                                    {gstRowInfo && gstRowInfo.gstAmount ? numberFormat(gstRowInfo.gstAmount) : ""}
                                                </Typography>
                                            </div>
                                        ))}

                                    </>}
                            </>
                        </div>
                    </div>
                </div>

            </div>

            {editYourDetails && <YourDetailsSideBar open={editYourDetails} onClose={handleYourDetailsClose} onConfirm={handleYourDetailsConfirm} sideBarName={"yourDetails"} />}
            {editPartyDetails && <PartyDetailsSideBar open={editPartyDetails} onClose={handlePartyDetailsClose} onConfirm={handlePartyDetailsConfirm} sideBarName={"partyDetails"} />}
            {editGSTInfoDetails && <GSTDetailsSideBar open={editGSTInfoDetails} onClose={handleGSTInfoDetailsClose} onConfirm={handleGSTInfoDetailsConfirm} sideBarName={"gstinfoDetails"} />}
            {editInvoiceDetails && <InvoiceDetailsSideBar open={editInvoiceDetails} onClose={handleInvoiceDetailsClose} onConfirm={handleInvoiceDetailsConfirm} sideBarName={"invoiceDetails"} />}
            {editChargeDeduction && <ChargesAndDeductionsSideBar tripData={tripInfoData} open={editChargeDeduction} onClose={handleChargeDeductionClose} sideBarName={"chargeDeductionDetails"} />}
            {updateUpiDialog && <UpdateBankUpiDialog open={updateUpiDialog} onClose={handleUpiDialogClose} onConfirm={handleUpiDialogConfirm} bankId={singleInvoiceData && singleInvoiceData.bankDetails && singleInvoiceData.bankDetails.bankId ? singleInvoiceData.bankDetails.bankId : ""} />}
            {bankChangeOpen && <SelectBankSideBar open={bankChangeOpen} onClose={handleSelectBankSideBarClose} onConfirm={handleSelectBankSideBarConfirm} />}
            {termsAndConditionFlag && <TermsAndConditionsDialog open={termsAndConditionFlag} onClose={handleTermsClose} onConfirm={handleTermsConfirm} termsValue={termsAndConditionValue ? termsAndConditionValue : ""} invoiceId={singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.id ? singleInvoiceData.invoiceDetails.id : ""} />}
            {<TransactionDetailsSideBar customerId={singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerId ? singleInvoiceData.invoiceDetails.customerId : ""} transactionId={transactionDetail && transactionDetail.id ? transactionDetail.id : ""} />}
            {/* {paymentDeleteDialog && <DeleteTransactionDialog open={paymentDeleteDialog} paymentId={transactionDetail && transactionDetail.id ? transactionDetail.id : ""} onClose={handleDeletePaymentClose} onConfirm={handleDeletePaymentConfirm} />} */}
            {addBankDetailsOpen && <AddBankDetailsSideBar open={addBankDetailsOpen} onClose={handleAddBankDetailsClose} onConfirm={handleAddBankDetailsConfirm} />}
            {successCreation && <SuccessDialog open={successCreation} title={"Account Verified Successfully"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog open={failureCreation} title={"Account Verification Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetSingleInvoice: (invoiceId, onSuccess, onError) => {
        dispatch(getSingleInvoice(invoiceId, onSuccess, onError))
    },
    dispatchEditInvoice: (invoiceId, reqData, onSuccess, onError) => {
        dispatch(editInvoice(invoiceId, reqData, onSuccess, onError))
    }

});

const SingleInvoiceWithRouter = withRouter(SingleInvoice)
export default connect(mapStateToProps, mapDispatchToProps)(SingleInvoiceWithRouter);
